import { Link } from "react-router-dom";
import type { TollCoverageDto } from "@bi/types";

const dataBR = (iso: string) => iso.split("-").reverse().join("/");

/**
 * Aviso de cobertura do extrato Sem Parar. O pedágio das telas de frota vem SÓ
 * dos extratos importados em /frota/pedagio: quando o período não está coberto
 * por inteiro, o número de pedágio está incompleto (ou é desconhecido) — e a
 * tela precisa dizer isso, em vez de mostrar R$ 0,00 como se fosse dado.
 */
export function TollCoverageNotice({ coverage }: { coverage: TollCoverageDto | undefined }) {
  if (!coverage || coverage.status === "full") return null;
  const ate = coverage.coveredTo ? dataBR(coverage.coveredTo) : null;
  return (
    <div className="rounded-lg bg-amber-50 border border-amber-200 px-4 py-2.5 text-sm text-amber-800">
      {coverage.status === "none" ? (
        <>
          <strong>Pedágio sem extrato neste período.</strong>{" "}
          {ate ? `O último extrato Sem Parar importado vai até ${ate}` : "Nenhum extrato Sem Parar foi importado"} — o
          pedágio aparece como "sem extrato" e não entra no custo direto.
        </>
      ) : (
        <>
          <strong>Pedágio incompleto neste período.</strong> O extrato Sem Parar importado vai até {ate}; as passagens
          depois dessa data ainda não entram.
        </>
      )}{" "}
      <Link to="/frota/pedagio" className="font-medium underline">Importar extrato</Link>
    </div>
  );
}

/** Valor do pedágio na tabela: "sem extrato" em vez de R$ 0,00 quando o período não tem extrato. */
export const SEM_EXTRATO_TITLE = "Sem extrato Sem Parar importado para o período — importe em Frota › Pedágio";
